<epic-card
	[isCollapseAllowed]="false"
	class="order-kanban">
	<div start>
		<div class="order-kanban__left">
			<div
				class="order-kanban__name font-weight__semibold"
				i18n>
				Orders kanban
			</div>
			<div class="order-kanban__controls">
				@if (aclCanCreateOrder()) {
					<epic-button
						[epic-tooltip]="OrderKanbanName"
						[epic-tooltip-classes]="['epic-tooltip--square']"
						[classes]="['epic-button--square']"
						(click)="openAddOrderModal()">
						<epic-icon name="plus-mini" />
					</epic-button>
				}
			</div>
		</div>
	</div>
	<div end>
		<div class="order-kanban__right">
			<!-- <epic-icon-button
			iconHoverQuerySelector="path"
			[text]="ExportToCSVText"
			[background]="'var(--color__white)'"
			[hoverColor]="'var(--color__dark)'"
			[tooltipTextColor]="'var(--color__white)'"
			[iconHoverColor]="'var(--color__white)'"
			[iconName]="'csv'"></epic-icon-button> -->
			<epic-icon-button
				iconHoverQuerySelector="path"
				(click)="onChangeView()"
				[text]="ShowOrderListText"
				[background]="'var(--color__white)'"
				[hoverColor]="'var(--color__dark)'"
				[tooltipTextColor]="'var(--color__white)'"
				[iconHoverColor]="'var(--color__white)'"
				[iconName]="'kanban-left'"></epic-icon-button>
		</div>
	</div>
	<div class="order-kanban__body">
		<div class="kanban">
			@for (column of columns; track column.id) {
				<div class="kanban__column">
					<div class="kanban__head">
						<div
							class="kanban__color"
							[ngStyle]="{ 'background-color': column.color }"></div>
						<div class="kanban__title">{{ column.name }}</div>
						<div class="kanban__plus">
							@if (aclCanCreateOrder()) {
								<epic-button
									(click)="openAddOrderModal()"
									[classes]="'epic-button--circle'">
									<epic-icon name="plus-mini"></epic-icon>
								</epic-button>
							}
						</div>
					</div>
					<div
						cdkDropList
						#dropList="cdkDropList"
						[cdkDropListData]="column.data"
						[cdkDropListConnectedTo]="allColumns"
						class="kanban__item"
						(cdkDropListDropped)="drop($event)">
						@for (item of column.data; track item.order.id) {
							<div
								class="kanban__card with-status-color"
								[style.border-left-color]="item.order.priority?.colour"
								[ngClass]="{
									'kanban__card--movable': aclCanUpdateOrders(),
									kanban__marked: checkDateAndDsk(item.order),
								}"
								(dblclick)="goToOrder(item.order.id)"
								cdkDrag
								[cdkDragDisabled]="!aclCanUpdateOrders()"
								[cdkDragData]="item">
								<div class="kanban-card__container">
									<div class="kanban-card__content">
										<div class="row align__center justify__space-between">
											<div class="kanban__order">
												<span
													class="text-color__info clickable"
													(click)="goToOrder(item.order.id)">
													{{ item.order.number }}
												</span>
												<span
													class="font-weight__medium clickable"
													(click)="goToOrder(item.order.id)">
													{{ item.order.container_number }}
												</span>
											</div>
											<div
												#actions
												class="c-pointer kanban__more">
												<epic-icon name="more" />
											</div>
										</div>
										<div class="kanban__entity">
											<span
												class="clickable"
												(click)="goToEntity(item.order)">
												{{ showEntityName(item.order.entity) }}
											</span>
										</div>
										<div class="container-flex margin__top padding__right font-weight__medium">
											@if (!item.order.has_delivery_confirmation) {
												<span class="information_line-icon">
													<epic-icon
														[epic-tooltip]="textHasDeliveryConfirmation"
														name="deliveryx" />
												</span>
											} @else {
												<span class="information_line-icon">
													<epic-icon
														[epic-tooltip]="textHasDeliveryConfirmation"
														name="delivery+" />
												</span>
											}
											<span>{{ item.order.assigned_to?.first_name }} {{ item.order.assigned_to?.last_name }}</span>
										</div>
										<div class="row align__center justify__space-between margin__top--small padding__right">
											<div class="row gap--minimum align__center">
												@if (item.order.priority) {
													<div
														class="kanban-card__badge-icon"
														[epic-tooltip]="getItemTranslation(item.order.priority)"
														[ngStyle]="{ '--icon-colour': item.order.priority?.colour }">
														<epic-icon name="priority-border" />
													</div>
												}
												<div
													[class.c-pointer]="aclCanUpdateOrders()"
													(click)="changeConveyanceType(item.order)"
													class="kanban-card__badge"
													[style.color]="getTextColor(item.order.conveyance_type?.colour)"
													[style.background-color]="item.order.conveyance_type?.colour">
													{{ getItemTranslation(item.order.conveyance_type) }}
												</div>
											</div>
											<div class="kanban-card__take-date">
												{{ item.order.take_date | date: 'dd.MM.YYYY hh:mm' }}
											</div>
										</div>
										<div class="margin__top--small row align__center wrap gap--minimum">
											@if (item.order.status) {
												<div
													[class.c-pointer]="aclCanUpdateOrders()"
													(click)="changeOrderStatus(item.order)"
													class="kanban-card__badge"
													[style.color]="getTextColor(item.order.status?.colour)"
													[style.background-color]="item.order.status?.colour"
													[epic-tooltip]="textOrderStatus">
													{{ getItemTranslation(item.order.status) }}
												</div>
											}
											@if (aclCanReadStatuses() && aclCanReadInvoices() && aclCanReadCostInvoices()) {
												@if (item.order.order_payment_status) {
													<div
														[class.c-pointer]="aclCanUpdateOrders()"
														(click)="changePaymentStatus(item.order)"
														class="kanban-card__badge"
														[style.color]="getTextColor(item.order.order_payment_status?.colour)"
														[style.background-color]="item.order.order_payment_status?.colour"
														[epic-tooltip]="textOrderPaymentStatus">
														{{ getItemTranslation(item.order.order_payment_status) }}
													</div>
												}
											}
											@if (item.order.container_logistic_status) {
												<div
													[class.c-pointer]="aclCanUpdateOrders()"
													(click)="changeLogisticStatus(item.order)"
													class="kanban-card__badge"
													[style.color]="getTextColor(item.order.container_logistic_status?.colour)"
													[style.background-color]="item.order.container_logistic_status?.colour"
													[epic-tooltip]="textContainerLogisticStatus">
													{{ getItemTranslation(item.order.container_logistic_status) }}
												</div>
											}
											@if (item.order.container_clearance_status && item.order.conveyance_type) {
												<div
													[class.c-pointer]="aclCanUpdateOrders()"
													(click)="changeClearanceStatus(item.order)"
													class="kanban-card__badge"
													[style.color]="getTextColor(item.order.container_clearance_status?.colour)"
													[style.background-color]="item.order.container_clearance_status?.colour"
													[epic-tooltip]="textContainerCustomsStatus">
													{{ getItemTranslation(item.order.container_clearance_status) }}
												</div>
											}
										</div>
									</div>
								</div>

								<epic-popover [parentReference]="actions">
									<div popover-header>{{ item.order.number }}</div>
									<div
										class="epic-popover__list"
										popover-content>
										<div
											(click)="goToOrder(item.order.id)"
											class="epic-popover__item"
											i18n>
											Order details
										</div>
										<div
											class="epic-popover__item no-active"
											i18n>
											Download PDF
										</div>
										@if (aclCanDeleteOrder()) {
											<div
												(click)="deleteOrder(item.order)"
												class="epic-popover__item"
												i18n>
												Delete order
											</div>
										}
									</div>
								</epic-popover>
							</div>
						}
						@if (column.data.length > 0 && aclCanCreateTasks()) {
							<div class="kanban__add_task">
								<epic-button
									(click)="openAddOrderModal()"
									[classes]="'epic-button--circle'">
									<epic-icon name="plus-mini" />
								</epic-button>
							</div>
						}
					</div>
				</div>
			}
		</div>
		<div class="order-kanban__foot">
			<epic-button
				size="small"
				(click)="fetchMoreOrders()"
				[text]="textShowMoreCards"
				*ngIf="!allColumnsFull" />
		</div>
	</div>
</epic-card>
